<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                      <el-input v-model="formDatas.orderNo" style="width: 120px;" size="mini" placeholder="订单号"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择商户" style="width: 180px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.auwId" filterable clearable @change="partserch"
                        placeholder="请选择用户" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefUserWxList_data" :key="index" :label="item.auwName"
                            :value="item.auwId"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.orderYear" type="year" value-format="yyyy" placeholder="归属年"
                        style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.orderYearMonth" type="month" value-format="yyyyMM"
                        placeholder="归属年月" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-select size="mini" v-model="formDatas.aobType" clearable @change="partserch" placeholder="请选择类型"
                        style="width: 130px">
                        <el-option label="退款订单" :value="2" key="2"></el-option>
                        <el-option label="正常订单" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aobStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="退款" :value="2" key="2"></el-option>
                        <el-option label="正常" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aobHandlerStatusShop" clearable @change="partserch"
                        placeholder="请选择商户状态" style="width: 130px">
                        <el-option label="已结算" :value="2" key="2"></el-option>
                        <el-option label="未结算" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aobHandlerStatusUser" clearable @change="partserch"
                        placeholder="请选择用户状态" style="width: 130px">
                        <el-option label="已结算" :value="2" key="2"></el-option>
                        <el-option label="未结算" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增商户</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aobId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商户' : '新增商户'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户名称" prop="asName">
                                <el-input v-model="form.asName" style="width: 80%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="商户编码" prop="asNumber">
                                <el-input v-model="form.asNumber" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="主体信息" prop="asMainBody">
                                <el-input v-model="form.asMainBody" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经营信息" prop="asMainBusiness">
                                <el-input v-model="form.asMainBusiness" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="结算账户" prop="asSettlementAccount">
                                <el-input v-model="form.asSettlementAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户号" prop="asWechatAccount">
                                <el-input v-model="form.asWechatAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户地址" prop="asAddress">
                                <el-input v-model="form.asAddress" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照照片" prop="asBaseBusinessLicense">
                                <el-input v-model="form.asBaseBusinessLicense" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="法人身份证人面" prop="asBaseIdcardFace">
                                <el-input v-model="form.asBaseIdcardFace" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="法人身份证国徽" prop="asBaseIdcardNationalEmblem">
                                <el-input v-model="form.asBaseIdcardNationalEmblem" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="门头照片" prop="asBaseShopHeader">
                                <el-input v-model="form.asBaseShopHeader" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="店内照片" prop="asBaseShopIn">
                                <el-input v-model="form.asBaseShopIn" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="法人手机号" prop="asBaseLegalPersonPhone">
                                <el-input v-model="form.asBaseLegalPersonPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="法人银行卡开户行" prop="asOpenBank">
                                <el-input v-model="form.asOpenBank" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="法人银行卡号" prop="asOpenBankAccount">
                                <el-input v-model="form.asOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="asEmail">
                                <el-input v-model="form.asEmail" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div v-if="detailData && detailData.aawType == 1">
                    <el-card
                        style="width: 70%;margin: 10px auto;padding: 15px;display: flex;justify-content:center;align-items:flex-start;flex-direction: column;">
                        <div style="margin: 10px auto;font-size: 20px;font-weight: 600;"
                            :style="{ 'color': detailData.aawStatus == 1 ? '#67C23A' : detailData.aawStatus == 2 ? '#67C23A' : '#F56C6C' }">
                            {{ detailData.aawStatus == 1 ? '创建' : detailData.aawStatus == 2 ? '成功' : '失败' }}</div>
                        <div>订单时间:{{ detailData.aawCreatetime }}</div>
                    </el-card>
                    <el-card v-if="detailData" style="width: 70%;margin: 20px auto;padding: 15px;">
                        <el-descriptions style="width: 100%;" :column="1" border :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            width: '14%',
                            fontSize: '12px'
                        }" :contentStyle="{
                            textAlign: 'center',
                            width: '20%',
                            fontSize: '12px'
                        }">
                            <el-descriptions-item label="商户名称">{{ detailData.asName || '' }}</el-descriptions-item>
                            <el-descriptions-item label="申请人名称">{{ detailData.aawName || '' }}</el-descriptions-item>
                            <el-descriptions-item label="订单编号">{{ detailData.outBillNo || '' }}</el-descriptions-item>
                            <el-descriptions-item label="申请金额">{{ detailData.aawMoneyYuan ||
                                '' }}元</el-descriptions-item>
                            <el-descriptions-item label="提现方式">{{ detailData.aawType ==
                                '1' ? '微信转账' : '对公打款' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '1'" label="微信转账单号">{{
                                detailData.transferBillNo || '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '1'" label="单据状态">{{ detailData.state ||
                                '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '1'" label="微信转账状态">{{
                                detailData.wxTransferStatus == '1' ? '用户申请中' : detailData.wxTransferStatus ==
                                    '2' ? '已转账待用户接受' : detailData.wxTransferStatus ==
                                        '3' ? '后台确认用户是否接收中' : detailData.wxTransferStatus == '4' ? '用户已接收' : '失败'
                            }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '1'" label="微信转账失败描述">{{
                                detailData.wxTransferStatusDes || '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '2'" label="打款描述">{{
                                detailData.aawDes || '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '2'" label="处理人">{{
                                detailData.handlerusername || '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '2'" label="处理时间">{{
                                detailData.handlerTime || '' }}</el-descriptions-item>
                            <el-descriptions-item v-if="detailData.aawType == '2'" label="打款截图"> <template
                                    v-if="detailData && detailData.aawReturn">
                                    <div v-for="(item, index) in detailData.aawReturn.split(',')" :key="index">
                                        <el-image ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                            style="width: 100px;"
                                            :preview-src-list="detailData.aawReturn.split(',')"></el-image>
                                    </div>
                                </template></el-descriptions-item>
                            <el-descriptions-item label="提现处理结果描述(失败原因)">{{
                                detailData.aawResult || '' }}</el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </div>
                <div v-else>
                    <el-card
                        style="width: 70%;margin: 20px auto;padding: 15px;display: flex;justify-content:center;align-items: center;flex-direction: column;">
                        <div style="margin: 20px auto;font-size: 20px;font-weight: 600;">账户收款:</div>
                        <div style="margin: 20px auto;font-size: 22px;font-weight: 600;color: #67C23A;"> +
                            {{ detailData.acrExchangeShopYuan || '0' }}元</div>
                    </el-card>
                    <el-card v-if="detailData" style="width: 70%;margin: 20px auto;padding: 15px;">
                        <el-descriptions style="width: 100%;" :column="1" border :labelStyle="{
                            color: '#409EFF',
                            textAlign: 'center',
                            width: '14%',
                            fontSize: '12px'
                        }" :contentStyle="{
                            textAlign: 'center',
                            width: '20%',
                            fontSize: '12px'
                        }">
                            <el-descriptions-item label="卡卷">{{ detailData.acrCode }}</el-descriptions-item>
                            <el-descriptions-item label="制卡时间">{{ detailData.acrYearMonth }}</el-descriptions-item>
                            <el-descriptions-item label="核销时间">{{ detailData.acrExchangeTime }}</el-descriptions-item>
                            <el-descriptions-item label="实物截图">
                                <template v-if="detailData && detailData.acrExchangeImages">
                                    <div v-for="(item, index) in detailData.acrExchangeImages.split(',')" :key="index">
                                        <el-image ref="scrImg" id="scrimg" :src="item" alt="" fit="cover"
                                            style="width: 100px;"
                                            :preview-src-list="detailData.acrExchangeImages.split(',')"></el-image>
                                    </div>
                                </template>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </div>

            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {getAjefUserWxList, getAjefOrderBillList, addAjefShop, updateAjefShop, deleteAjefShop, getAjefShopList, getAjefShopBillDetails } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAjefUserWxList_data: [],
            theItem: '',
            detailData: [],
            IsDetail: false,
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
                { id: 1, name: "闲置" },
                { id: 2, name: "领用" },
                { id: 3, name: "损坏" },
                { id: 4, name: "丢失" },
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'aobId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderNo",
                    key: "orderNo",
                    title: "订单号",
                    align: "center",
                    fixed: 'left',
                    width: 200,
                },
                {
                    field: "orderYearMonth",
                    key: "orderYearMonth",
                    title: "账单所属年月",
                    align: "center",
                    // fixed: 'left',
                    width: 160,
                },
                {
                    field: "aobTitle",
                    key: "aobTitle",
                    title: "商品描述",
                    align: "center",
                    width: 260,
                },
                {
                    field: "orderNoSub",
                    key: "orderNoSub",
                    title: "子订单号",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserPayYuan",
                    key: "aobUserPayYuan",
                    title: "支付金额",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserSettlementYuan",
                    key: "aobUserSettlementYuan",
                    title: "可用于结算金额",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserFreightYuan",
                    key: "aobUserFreightYuan",
                    title: "支付运费",
                    align: "center",
                    width: 160,
                },
                {
                    field: "aobUserRefundYuan",
                    key: "aobUserRefundYuan",
                    title: "退款金额",
                    align: "center",
                    width: 160,
                },

                { field: "orderTimePay", key: "orderTimePay", title: "交易时间", width: 160, align: "center" },
                { field: "orderTimeComplete", key: "orderTimeComplete", title: "完成时间", width: 160, align: "center" },
                { field: "orderTimeRefund", key: "orderTimeRefund", title: "退款时间", width: 160, align: "center" },
                {
                    field: "aobType",
                    key: "aobType",
                    title: "交易类型",
                     fixed: "right",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobType == 1 ? <el-tag >正常交易</el-tag> : <el-tag type="danger">退款</el-tag>;
                    },
                },
                {
                    field: "aobHandlerStatusUser",
                    key: "aobHandlerStatusUser",
                    title: "用户结算状态",
                    align: "center",
                     fixed: "right",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobHandlerStatusUser == 1 ? <el-tag >未结算</el-tag> : <el-tag type="danger">已结算</el-tag>;
                    },
                },
                {
                    field: "aobHandlerStatusShop",
                    key: "aobHandlerStatusShop",
                    title: "商家结算状态",
                    fixed: "right",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobHandlerStatusShop == 1 ? <el-tag >未结算</el-tag> : <el-tag type="danger">已结算</el-tag>;
                    },
                },
                {
                    field: "aobStatus",
                    key: "aobStatus",
                    title: "状态",
                    align: "center",
                    fixed: "right",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.aobStatus == 1 ? <el-tag >正常</el-tag> : <el-tag type="danger">退款</el-tag>;
                    },
                },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 80,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleDetail(row)}
                //                 >
                //                     详情
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopList({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        getAjefUserWxList({ pageSize: 0 }).then(res => {
            this.getAjefUserWxList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        handleDetail(row) {
            this.theItem = '';
            getAjefShopBillDetails({ aobId: row.aobId }).then(res => {
                this.detailData = res.data
                this.IsDetail = true
                if (res.item) {
                    this.theItem = res.item;
                }

            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ aobId: this.theRow.aobId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjefShop({ aobIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjefShop({ aobId: row.aobId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aobId = row.aobId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefOrderBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefOrderBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefOrderBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>